var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchWhite56(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-white-56_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".search-white-56_svg__st8{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M987.4 1019.3c-8.3 0-16.6-3.2-23-9.5L664.2 709.5c-12.7-12.7-12.7-33.3 0-46 12.7-12.7 33.3-12.7 46 0l300.3 300.3c12.7 12.7 12.7 33.3 0 46-6.4 6.3-14.8 9.5-23.1 9.5zM364.4 72c39.4 0 77.7 7.7 113.6 22.9 34.8 14.7 66 35.8 92.8 62.6 26.8 26.8 47.9 58.1 62.6 92.8 15.2 36 22.9 74.2 22.9 113.6s-7.7 77.7-22.9 113.6c-14.7 34.8-35.8 66-62.6 92.8-26.8 26.9-58 48-92.8 62.7-36 15.2-74.2 22.9-113.6 22.9s-77.7-7.7-113.6-22.9c-34.8-14.7-66-35.8-92.8-62.6-26.8-26.8-47.9-58.1-62.6-92.8-15.2-36-22.9-74.2-22.9-113.6s7.7-77.7 22.9-113.6c14.7-34.8 35.8-66 62.6-92.8 26.8-26.8 58.1-47.9 92.8-62.6 35.9-15.3 74.1-23 113.6-23m0-65C167.2 7 7.4 166.8 7.4 364c0 197.1 159.8 357 357 357 197.1 0 357-159.8 357-357-.1-197.2-159.9-357-357-357z"
  })));
}

export default SvgSearchWhite56;